"use client";

import { c as _c } from "react/compiler-runtime";
import LatestActivityRow from "@/components/latest-activity/LatestActivityRow";
import { TransferSingleActions } from "@/components/nft-transfer/TransferSingle";
import { MEMELAB_CONTRACT } from "@/constants/constants";
import type { LabNFT } from "@/entities/INFT";
import { CollectedCollectionType } from "@/entities/IProfile";
import type { Transaction } from "@/entities/ITransaction";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { ContractType } from "@/types/enums";
function MemeLabYourCardsTransferCard(t0) {
  const $ = _c(14);
  const {
    nft,
    nftBalance
  } = t0;
  const {
    isMobileDevice
  } = useDeviceInfo();
  const t1 = isMobileDevice ? "Your Cards" : "Cards";
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-iron-500">{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `x${nftBalance}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <span className="tw-whitespace-nowrap tw-text-sm tw-font-bold tw-text-white">{t3}</span>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div className="tw-flex tw-w-full tw-flex-none tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-6 tw-gap-y-3 @lg:tw-w-auto @lg:tw-justify-start"><div className="tw-inline-flex tw-items-baseline tw-gap-1.5 tw-whitespace-nowrap">{t2}{t4}</div></div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isMobileDevice || $[8] !== nft || $[9] !== nftBalance) {
    t6 = !isMobileDevice && <div className="tw-flex tw-w-full tw-min-w-0 tw-items-center tw-gap-x-6 @lg:tw-w-auto @lg:tw-flex-1"><div className="tw-hidden tw-h-10 tw-w-px tw-shrink-0 tw-bg-iron-800 @lg:tw-block" /><div className="tw-min-w-0 tw-flex-1"><TransferSingleActions collectionType={CollectedCollectionType.MEMELAB} contractType={ContractType.ERC1155} contract={MEMELAB_CONTRACT} tokenId={nft.id} max={nftBalance} title={nft.name} thumbUrl={nft.thumbnail} /></div></div>;
    $[7] = isMobileDevice;
    $[8] = nft;
    $[9] = nftBalance;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="tw-mb-3"><div className="tw-w-full tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-shadow-2xl tw-ring-1 tw-ring-white/5" data-testid="transfer-single"><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-4 tw-px-4 tw-py-4 tw-@container">{t5}{t6}</div></div></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
export function MemeLabYourTransactionsTable(t0) {
  const $ = _c(4);
  const {
    transactions
  } = t0;
  if (transactions.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== transactions) {
    t1 = transactions.map(_temp);
    $[0] = transactions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <section><div className="tw-w-full tw-overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden"><table className="tw-min-w-full tw-border-separate tw-border-spacing-0"><tbody>{t1}</tbody></table></div></section>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(transaction) {
  return <LatestActivityRow tr={transaction} variant="tailwind" rowStyle="striped" key={`${transaction.from_address}-${transaction.to_address}-${transaction.transaction}-${transaction.token_id}`} />;
}
export function MemeLabYourCardsPanel(t0) {
  const $ = _c(3);
  const {
    nft,
    nftBalance
  } = t0;
  if (!nft || nftBalance <= 0) {
    return null;
  }
  let t1;
  if ($[0] !== nft || $[1] !== nftBalance) {
    t1 = <div className="tw-pb-[35px]"><MemeLabYourCardsTransferCard nft={nft} nftBalance={nftBalance} /></div>;
    $[0] = nft;
    $[1] = nftBalance;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}